import { Redirect, Route, Switch, useRouteMatch } from "react-router-dom";

import { useOrganisationContext } from "@/contexts/organisations/OrganisationContext";
import { ERROR_404_URL } from "@/core/urls";
import useDocTitle from "@/hooks/use-doc-title";

import Payment from "./Payment";
import SetUp from "./SetUp";
import Settings from "./Settings";
import TeamMembers from "./TeamMembers";

export default function Routes() {
  const match = useRouteMatch();

  useDocTitle("Organisation", false, "Regenerus");

  const { organisation } = useOrganisationContext();

  return (
    <Switch>
      <Redirect exact to={`${match.url}/payment`} from={match.path} />
      <Route exact path={`${match.path}/payment`}>
        {organisation?.onboardingStatus === "not_started" ? <SetUp /> : <Payment />}
      </Route>
      <Route exact path={`${match.path}/settings`}>
        <Settings />
      </Route>
      <Route exact path={`${match.path}/team_members`}>
        <TeamMembers />
      </Route>
      <Redirect to={ERROR_404_URL} />
    </Switch>
  );
}
